import { useAuthStore } from "@/stores/authStore";
import { useShallow } from "zustand/react/shallow";

export function useCurrentUser() {
  return useAuthStore(
    useShallow((s) => ({
      isAuthed: !!s.token,
      token: s.token,
      user: s.user,
      hasHydrated: s.hasHydrated,
      logout: s.logout,
    }))
  );
}